/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CustomerEntry } from './CustomerEntry.js';
import {
    CustomerEntryFromJSON,
    CustomerEntryFromJSONTyped,
    CustomerEntryToJSON,
} from './CustomerEntry.js';

/**
 * 
 * @export
 * @interface GetContactFieldsResponse
 */
export interface GetContactFieldsResponse {
    /**
     * 
     * @type {Array<CustomerEntry>}
     * @memberof GetContactFieldsResponse
     */
    data?: Array<CustomerEntry>;
    /**
     * 
     * @type {number}
     * @memberof GetContactFieldsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactFieldsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactFieldsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetContactFieldsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetContactFieldsResponse interface.
 */
export function instanceOfGetContactFieldsResponse(value: object): boolean {
    return true;
}

export function GetContactFieldsResponseFromJSON(json: any): GetContactFieldsResponse {
    return GetContactFieldsResponseFromJSONTyped(json, false);
}

export function GetContactFieldsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactFieldsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CustomerEntryFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetContactFieldsResponseToJSON(value?: GetContactFieldsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CustomerEntryToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

